import { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ResetPassword({ token, onSwitchToLogin }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords don't match");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      // XHR adapter — see Login.jsx for the PostHog fetch monkey-patch note.
      await axios.post(
        `${API_URL}/api/auth/reset-password`,
        { token, password },
        { adapter: "xhr", headers: { "Content-Type": "application/json" } }
      );
      setSuccess(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (typeof detail === "string") {
        setError(detail);
      } else if (err?.response) {
        setError("Reset failed");
      } else {
        setError("Connection failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-12">
          <div className="w-12 h-12 bg-[#9FFF00] flex items-center justify-center">
            <span className="text-black font-black text-base">ID</span>
          </div>
          <h1 className="text-2xl font-black tracking-tight text-white">
            INFLUENCE<span className="text-[#9FFF00]">DETECTOR</span>
          </h1>
        </div>

        {success ? (
          <div className="text-center">
            <p className="text-white text-sm mb-4">Password reset successfully!</p>
            <button onClick={onSwitchToLogin} className="py-3 px-8 bg-[#9FFF00] text-black font-bold uppercase tracking-wider hover:bg-[#8AE600]">
              Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-white/50 text-sm text-center mb-4">Enter your new password</p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password (min 6 characters)"
              className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
              autoFocus
              data-testid="reset-password-input"
            />
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirm new password"
              className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
              data-testid="reset-confirm-input"
            />
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading || !password || !confirm}
              className="w-full py-3 bg-[#9FFF00] text-black font-bold uppercase tracking-wider hover:bg-[#8AE600] disabled:opacity-50 transition-colors"
              data-testid="reset-submit-button"
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
